import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { Country } from '@shs-digi-care-monorepo/interfaces';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'sh-country',
    templateUrl: './sh-country.component.html',
    standalone: true,
    imports: [TranslatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ShCountryComponent {
    public countryCode: InputSignal<string | Country> = input<string | Country>('');
    /** Renders the flag as a circle instead of the default rounded square. */
    public rounded: InputSignal<boolean> = input<boolean>(false);
}
